<template>
    <div class="animated fadeIn">
        <div>
            <b-card>
                <div slot="header">
                    <strong style="margin-left: 5px">Create Access for project "{{ activeProject.name }}"</strong>
                </div>

                <div role="tablist" class="tabbed-form">
                    <b-card no-body class="mb-1">
                        <b-card-header @click="toggleStep(0)" header-tag="header" class="p-1 form-step-name" role="tab">
                            <img src="../../../assets/gcp-icons/step1.png" />
                            {{ tabs[0] }}
                        </b-card-header>
                        <b-collapse v-model="tabOpen[0]" visible role="tabpanel">
                            <b-card-body>
                                <b-form class="step-form">
                                    <b-form-group label="Member" :label-cols="2" :horizontal="true">
                                        <b-row>
                                            <b-col md="8"
                                                ><b-form-input
                                                    v-model="$v.formData.member.$model"
                                                    type="text"
                                                    ref="member-name"
                                                    placeholder="Enter member e-mail adress"
                                                    disabled
                                                ></b-form-input>
                                                <Feedback
                                                    :state="validateRef('formData.member', 0)"
                                                    invalid="This field is required and must be a valid email"
                                                    valid="E-mail is valid"
                                                ></Feedback>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                    <b-form-group label="Viewer" :label-cols="2" :horizontal="true">
                                        <b-row>
                                            <b-col md="8"
                                                ><treeselect
                                                    :multiple="true"
                                                    valueFormat="object"
                                                    valueConsistsOf="LEAF_PRIORITY"
                                                    :options="viewerOptions"
                                                    v-model="$v.formData.viewer.$model"
                                                    :searchable="true"
                                                    :normalizer="categoryNormalizer"
                                                    placeholder="Select categories"
                                                    :disabled="formData.viewerAccessAll"
                                                    @select="cleanupEditorCategories"
                                                    @deselect="pushEditorCategories"
                                                    :beforeClearAll="() => (this.editorOptions = [...this.categories])"
                                                ></treeselect>
                                            </b-col>
                                            <b-col md="8" id="viewer-all-column">
                                                <b-form-checkbox
                                                    id="viewer-all"
                                                    class="access-checkbox"
                                                    v-model="$v.formData.viewerAccessAll.$model"
                                                    name="viewer-all"
                                                    :value="true"
                                                    :unchecked-value="false"
                                                >
                                                    Grant Viewer Access to all Categories
                                                </b-form-checkbox>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>

                                    <b-form-group label="Editor" :label-cols="2" :horizontal="true">
                                        <b-row>
                                            <b-col md="8"
                                                ><treeselect
                                                    :multiple="true"
                                                    valueFormat="object"
                                                    valueConsistsOf="LEAF_PRIORITY"
                                                    :options="editorOptions"
                                                    v-model="$v.formData.editor.$model"
                                                    :searchable="true"
                                                    :normalizer="categoryNormalizer"
                                                    placeholder="Select categories"
                                                    :disabled="formData.editorAccessAll"
                                                    @select="cleanupViewerCategories"
                                                    @deselect="pushViewerCategories"
                                                    :beforeClearAll="() => (this.viewerOptions = [...this.categories])"
                                                ></treeselect>
                                            </b-col>
                                            <b-col md="8" id="editor-all-column">
                                                <b-form-checkbox
                                                    id="editor-all"
                                                    class="access-checkbox"
                                                    v-model="$v.formData.editorAccessAll.$model"
                                                    name="editor-all"
                                                    :value="true"
                                                    :unchecked-value="false"
                                                >
                                                    Grant Editor Access to all Categories
                                                </b-form-checkbox>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>

                                    <Feedback
                                        :state="permissionError.state"
                                        :invalid="permissionError.message"
                                    ></Feedback>

                                    <b-row>
                                        <b-col>
                                            <Feedback
                                                v-if="checkPage[0]"
                                                :state="validateRef('formData.member', 0)"
                                                invalid="You need to finish this step before accessing the next one"
                                                valid="This step is complete"
                                            ></Feedback>
                                            <b-button
                                                @click="updatePermission"
                                                :disabled="checkPage[0] && $v.formData.name.$invalid"
                                                variant="primary"
                                            >
                                                <i class="icon-check"></i> Update
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </b-card>
        </div>
        <Loading :loading="$store.state.loading.processing" :text="$store.state.loading.text"></Loading>
    </div>
</template>

<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import Feedback from '@/components/Feedback'
import Loading from '@/components/loading.vue'

import {validationMixin} from 'vuelidate'
import {required, email} from 'vuelidate/lib/validators'

import {mapGetters} from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import {filterDirty} from '@/shared/filterDirty.js'

export default {
    data() {
        return {
            tabs: ['Permission settings'],
            tabIndex: 0,
            formData: {
                member: null,
                viewer: [],
                viewerAccessAll: false,
                editor: [],
                editorAccessAll: false,
            },
            viewerOptions: [],
            editorOptions: [],
            permissionError: {
                state: true,
                message: '',
            },
        }
    },
    mixins: [validationMixin],
    validations: {
        formData: {
            member: {
                email,
                required,
            },
            viewer: {},
            viewerAccessAll: {},
            editor: {},
            editorAccessAll: {},
        },
    },
    components: {
        Treeselect,
        Feedback,
        Loading,
    },
    computed: {
        ...mapGetters({
            activeProject: 'project/active',
            categories: 'category/categories',
        }),
        tabOpen() {
            return this.tabs.map((tab, index) => (index === this.tabIndex ? true : false))
        },
    },
    async created() {
        this.$store.commit('loading/PROCESSING', `Fetching the Permission...`)
        this.checkPage = this.tabs.map(el => false)
        const categories = await this.$store.dispatch('category/getCategories', this.activeProject.id)
        await this.fetchPermission()
        this.$store.commit('loading/PROCESSED')
    },
    methods: {
        async fetchPermission() {
            const {id} = this.$route.params
            const permission = await this.$store.dispatch('permission/fetchPermission', id)
            this.formData = {
                member: permission.member,
                viewer: this.categories.filter(el =>
                    permission.access.find(
                        access => access.categoryRef && access.categoryRef.id === el.id && access.role === 'Viewer'
                    )
                ),
                viewerAccessAll: Boolean(
                    permission.access.find(access => access.all === true && access.role === 'Viewer')
                ),
                editor: this.categories.filter(el =>
                    permission.access.find(
                        access => access.categoryRef && access.categoryRef.id === el.id && access.role === 'Editor'
                    )
                ),
                editorAccessAll: Boolean(
                    permission.access.find(access => access.all === true && access.role === 'Editor')
                ),
            }
            this.viewerOptions = this.categories.filter(
                el =>
                    !permission.access.find(
                        access => access.categoryRef && access.categoryRef.id === el.id && access.role === 'Editor'
                    )
            )
            this.editorOptions = this.categories.filter(
                el =>
                    !permission.access.find(
                        access => access.categoryRef && access.categoryRef.id === el.id && access.role === 'Viewer'
                    )
            )
            this.fetchedFormData = Object.assign({}, this.formData)
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        updatePermission() {
            const formDirty = filterDirty(this.formData, this.$v.formData, this.fetchedFormData)
            if (Object.keys(formDirty).length > 0) {
                const viewerAccess = []

                if (this.formData.viewerAccessAll) {
                    viewerAccess.push({role: 'Viewer', all: true})
                } else {
                    viewerAccess.push(
                        ...this.formData.viewer.map(el => ({
                            role: 'Viewer',
                            categoryId: el.id,
                        }))
                    )
                }

                const editorAccess = []

                if (this.formData.editorAccessAll) {
                    editorAccess.push({role: 'Editor', all: true})
                } else {
                    editorAccess.push(
                        ...this.formData.editor.map(el => ({
                            role: 'Editor',
                            categoryId: el.id,
                        }))
                    )
                }

                const data = {
                    id: this.$route.params.id,
                    permissionData: {
                        access: [...viewerAccess, ...editorAccess],
                    },
                }

                const self = this
                this.$store.commit('loading/PROCESSING', `Updating Access...`)
                this.$store
                    .dispatch('permission/updatePermission', data)
                    .then(permission => {
                        this.$store.commit('loading/PROCESSED')
                        this.$router.push({
                            path: '/iam/permission',
                        })
                    })
                    .catch(exception => {
                        this.permissionError.state = false
                        this.permissionError.message = exception.response.data
                        self.$store.commit('loading/PROCESSED')
                    })
            }
            this.$router.push({
                path: '/iam/permission',
            })
        },

        validateRef(ref) {
            const keys = ref.split('.')
            const validateField = keys.reduce((a, c) => {
                return a[c]
            }, this.$v)

            return validateField.$dirty ? !validateField.$invalid : null
        },

        categoryNormalizer(category) {
            return {
                id: category.id,
                label: category.name,
            }
        },

        toggleStep(step) {
            this.tabIndex = step
            this.$forceUpdate()
        },

        cleanupViewerCategories(node, instanceId) {
            this.formData.viewer = this.formData.viewer.filter(el => el.id !== node.id)
            this.viewerOptions = this.viewerOptions.filter(el => el.id !== node.id)
        },

        cleanupEditorCategories(node, instanceId) {
            this.formData.editor = this.formData.editor.filter(el => el.id !== node.id)
            this.editorOptions = this.editorOptions.filter(el => el.id !== node.id)
        },

        pushViewerCategories(node) {
            this.viewerOptions.push(node)
        },

        pushEditorCategories(node) {
            this.editorOptions.push(node)
        },
    },
}
</script>

<style lang="scss">
.access-checkbox {
    margin-top: 1rem;
}
</style>
